import * as React from 'react';
import { canVote } from '../../Election';
import { ElectionStatus, VoteResult } from '../../_generatedTypes.g';
import { getElectionById, getCandidateById, getPartyById } from '../../selectors';
import { CandidateButtonRow } from './CandidateButtonRow';
import { CandidatePage } from './CandidatePage';
import { ConfirmVote } from './ConfirmVote';
import { useEffect, useState } from 'react';
import { getTranslator } from '../../Translator';
import { useParams } from 'react-router-dom';
import { useAppSelector } from '../../hooks';

type CandidateComponentParams = {
    candidateId: string;
}

export const CandidateComponent = () => {
    const candidates = useAppSelector(state => state.candidates);
    const parties = useAppSelector(state => state.parties);
    const elections = useAppSelector(state => state.elections);
    const language = useAppSelector(state => state.language);

    const t = getTranslator(language);

    const candidateId = Number(useParams<CandidateComponentParams>().candidateId);
    const candidate = getCandidateById(candidates, candidateId);
    const party = getPartyById(parties, candidate.PartyId);
    if (!party) {
        //workaround bug: toevoegen kandidaat kandidaatsysteem voegt geen partij toe aan state.
        location.reload();
    }
    const election = getElectionById(elections, party.ElectionId);
    const userCanVote = canVote(election);
    const userDidVote = election.VoteResult === VoteResult.Success;

    useEffect(() => {
        if (userDidVote) {
            setUserIsVoting(false);
        }
    }, [userDidVote])

    const [userIsVoting, setUserIsVoting] = useState<boolean>(false);

    let pageTitle, instruction;

    if (userCanVote) {
        if (userIsVoting) {
            pageTitle = t['Confirm vote'];
            instruction = undefined;
        } else {
            pageTitle = t['Vote for '] + candidate.Name;
            instruction = t['Verify that you selected the right candidate and click \'Confirm vote\'.'];
        }
    } else {
        pageTitle = `${t['Candidate']} ${candidate.Name}`;
        instruction = userDidVote
            ? t['You have voted! You can log out now.']
            : t['This screen presents information about the selected candidate.'];
    }
    const someHtml = (
        <div className="popup-help">
            {election.ElectionStatus == ElectionStatus.CandidacyPeriod ?
                <>
                    <h2>{t.translate({ NL: 'Kandidaatstelling/verkiezing vullen:', EN: 'Fill in your candidacy/election form:' })}</h2>
                    <ul>
                        <li>{t.translate({ NL: 'Indien je je kandidaatstelling wilt goedkeuren, klik je op de knop ‘keur mijn kandidaatstelling goed’.', EN: 'If you wish to approve your candidacy, click on the ‘approve my candidacy’ button.' })}</li>
                        <li>{t.translate({ NL: 'Door op de knop ‘bewerken’ te klikken kun je de foto, slogan en verkiezingstekst wijzigen. Klik op ‘opslaan’ als je klaar bent met bewerken.', EN: 'By clicking on the ‘edit’ button you can change the photo, slogan and election text. Click ‘save’ when you have finished editing' })}</li>
                    </ul>
                </>
                :
                <>
                    <h2>{t.translate({ NL: 'Stemmen:', EN: 'Vote' })}</h2>
                    <p>{instruction}</p>
                </>
            }
        </div>
    )


    return <CandidatePage candidate={candidate} pageTitle={pageTitle} helpText={someHtml} lang={t.languageCode}>
        {userIsVoting
            ? <ConfirmVote candidateId={candidate.CandidateId} onCancel={() => setUserIsVoting(false)} />
            : <CandidateButtonRow candidateId={candidate.CandidateId} onClickVote={() => setUserIsVoting(true)} />}
    </CandidatePage>
}
